import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App.jsx";
import { StoreProvider } from "@/context/index.jsx";

createRoot(document.getElementById("root")).render(
  <BrowserRouter basename="/">
    <StoreProvider>
      <App />
    </StoreProvider>
  </BrowserRouter>
);
